(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wtc-help-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__wtcHelpInit) return; window.__wtcHelpInit = true;

  function closeAll(scope){ (scope||document).querySelectorAll('.hc-card').forEach(function(c){ c.classList.remove('is-open'); var h=c.querySelector('.hc-card-head'); if(h) h.setAttribute('aria-expanded','false'); }); }

  document.addEventListener('click', function(e){
    var head = e.target.closest && e.target.closest('.hc-card-head');
    if (head){
      var card = head.closest('.hc-card');
      var open = card.classList.contains('is-open');
      var grid = card.closest('.hc-grid, .hc-membership-card') || document;
      grid.querySelectorAll('.hc-card').forEach(function(c){ c.classList.remove('is-open'); var h=c.querySelector('.hc-card-head'); if(h) h.setAttribute('aria-expanded','false'); });
      if(!open){ card.classList.add('is-open'); head.setAttribute('aria-expanded','true'); }
      return;
    }
    var q = e.target.closest && e.target.closest('.hc-q');
    if (q){
      var ans = q.nextElementSibling;
      if(!ans || !ans.classList.contains('hc-a')) return;
      var c = q.closest('.hc-card');
      var isOpen = ans.classList.contains('is-open');
      c.querySelectorAll('.hc-a').forEach(function(a){ a.classList.remove('is-open'); });
      c.querySelectorAll('.hc-q').forEach(function(qq){ qq.classList.remove('is-open'); });
      if(!isOpen){ ans.classList.add('is-open'); q.classList.add('is-open'); }
      return;
    }
    var pill = e.target.closest && e.target.closest('.hc-quick a');
    if (pill){
      var hash = pill.getAttribute('href');
      if(!hash || hash.indexOf('#')!==0) return;
      var target = document.querySelector(hash);
      if(!target) return;
      e.preventDefault();
      closeAll();
      target.classList.add('is-open');
      target.scrollIntoView({behavior:'smooth', block:'start'});
    }
  });

  function escapeHtml(s){ return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function escapeRegex(s){ return s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'); }
  function highlight(t,q){ if(!q) return escapeHtml(t); var re=new RegExp('('+escapeRegex(q)+')','gi'); return escapeHtml(t).replace(re,'<mark class="hc-mark">$1</mark>'); }
  function cacheQ(){ document.querySelectorAll('.hc-q').forEach(function(qb){ var sp=qb.querySelector('span:not(.hc-q-icon)'); if(sp && !sp.dataset.originalText) sp.dataset.originalText=sp.textContent; }); }

  function performSearch(query){
    query=(query||'').trim().toLowerCase();
    var any=false;
    document.querySelectorAll('.hc-card').forEach(function(card){
      var matched=false;
      card.querySelectorAll('.hc-q').forEach(function(qb){
        var sp=qb.querySelector('span:not(.hc-q-icon)');
        var orig=sp?sp.dataset.originalText:qb.textContent;
        var qt=(orig||'').toLowerCase();
        var aEl=qb.nextElementSibling;
        var at=aEl?aEl.textContent.toLowerCase():'';
        if(!query){ if(sp)sp.textContent=orig; qb.style.display=''; qb.classList.remove('is-open'); if(aEl)aEl.classList.remove('is-open'); return; }
        var inQ=qt.indexOf(query)!==-1, inA=at.indexOf(query)!==-1;
        if(inQ||inA){ matched=true; qb.style.display=''; if(sp&&inQ){sp.innerHTML=highlight(orig,query);} else if(sp){sp.textContent=orig;} if(!inQ&&inA){qb.classList.add('is-open'); if(aEl)aEl.classList.add('is-open');} }
        else { qb.style.display='none'; qb.classList.remove('is-open'); if(aEl)aEl.classList.remove('is-open'); if(sp)sp.textContent=orig; }
      });
      if(!query){ card.classList.remove('is-open','hc-card--no-match'); }
      else if(matched){ card.classList.add('is-open'); card.classList.remove('hc-card--no-match'); any=true; }
      else { card.classList.remove('is-open'); card.classList.add('hc-card--no-match'); }
    });
    var banner=document.querySelector('.hc-search-empty');
    if(query && !any){
      if(!banner){ banner=document.createElement('div'); banner.className='hc-search-empty'; banner.innerHTML='<p>No matches for &ldquo;<span class="hc-search-empty-q"></span>&rdquo;. Try a different keyword, or browse a topic below.</p>'; var topics=document.querySelector('.hc-topics'); if(topics) topics.insertBefore(banner, topics.firstChild); }
      if(banner){ var qq=banner.querySelector('.hc-search-empty-q'); if(qq) qq.textContent=query; banner.style.display=''; }
    } else if(banner){ banner.style.display='none'; }
  }

  var timer;
  document.addEventListener('input', function(e){
    if(!e.target.classList || !e.target.classList.contains('hc-search-input')) return;
    cacheQ(); clearTimeout(timer); var v=e.target.value; timer=setTimeout(function(){ performSearch(v); },80);
  });
  document.addEventListener('keydown', function(e){
    if(e.target.classList && e.target.classList.contains('hc-search-input') && e.key==='Escape'){ e.target.value=''; performSearch(''); }
  });
  document.querySelectorAll('.hc-search').forEach(function(f){ if(f.tagName==='FORM') f.addEventListener('submit', function(ev){ ev.preventDefault(); }); });
  cacheQ();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wtc-membership-video"] && !Shopify.designMode) return;
  try {
    
  class WtcmVideoFacade extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-play]');
      this.template = this.querySelector('template[data-media]');
      if (!this.button || !this.template) return;
      this.button.addEventListener('click', this.#activate.bind(this), { once: true });
    }

    #activate() {
      const media = this.template.content.cloneNode(true);
      this.appendChild(media);
      this.classList.add('is-playing');

      const video = this.querySelector('video');
      if (!video) return;
      video.setAttribute('preload', 'auto');
      const playing = video.play();
      if (playing) playing.catch(() => video.setAttribute('controls', 'controls'));
    }
  }

  if (!customElements.get('wtcm-video-facade')) {
    customElements.define('wtcm-video-facade', WtcmVideoFacade);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wtc-sf-carbon-layers"] && !Shopify.designMode) return;
  try {
    
  class WtcCarbonLayers extends HTMLElement {
    #ticking = false;
    #active = false;
    #revealed = false;

    connectedCallback() {
      this.space = this.querySelector('[data-wcl-space]');
      this.stage = this.querySelector('.wcl__stage');
      if (!this.space || !this.stage) return;

      this.plies = Array.from(this.querySelectorAll('[data-wcl-ply]'));
      this.callouts = Array.from(this.querySelectorAll('[data-wcl-co]'));
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 919px)');

      // Reduced motion keeps the CSS default: fully exploded, nothing listening.
      if (this.reduced.matches) return;

      this.maxDesktop = Number(this.dataset.wclExplode) || 150;
      this.maxMobile = Number(this.dataset.wclExplodeMobile) || 64;

      this.onScroll = this.onScroll.bind(this);
      this.render = this.render.bind(this);

      this.io = new IntersectionObserver(
        (entries) => {
          this.#active = entries[0].isIntersecting;
          if (this.#active) {
            if (!this.#revealed) {
              this.#revealed = true;
              requestAnimationFrame(() => this.classList.add('wcl--in'));
            }
            this.render();
          }
        },
        { rootMargin: '-10% 0px' }
      );
      this.io.observe(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      // JS is running: arm the reveal and start CLOSED, one solid sheet.
      this.classList.add('wcl--armed');
      this.space.style.setProperty('--gap', '0');
      this.space.style.setProperty('--sweep', '0');
      if (!this.mobile.matches) {
        for (const co of this.callouts) co.style.setProperty('--co', '0');
      }
      this.render();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    #desktopProgress() {
      const rect = this.getBoundingClientRect();
      const travel = this.offsetHeight - window.innerHeight;
      if (travel <= 0) return 1;
      return Math.min(1, Math.max(0, -rect.top / travel));
    }

    // Mobile has no pin. Closed as the stage enters at the bottom of the screen,
    // open once its centre passes 45% of the viewport. Native scrolling only.
    #mobileProgress() {
      const rect = this.stage.getBoundingClientRect();
      const vh = window.innerHeight;
      const start = vh * 0.95;
      const end = vh * 0.45 + rect.height / 2;
      return Math.min(1, Math.max(0, (start - (rect.top + rect.height / 2)) / (start - end)));
    }

    render() {
      this.#ticking = false;
      const isMobile = this.mobile.matches;
      const maxGap = isMobile ? this.maxMobile : this.maxDesktop;
      const p = isMobile ? this.#mobileProgress() : this.#desktopProgress();

      // Hold closed briefly so the single sheet registers, then pull apart.
      const t = Math.min(1, Math.max(0, (p - 0.12) / 0.76));
      const eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;

      this.space.style.setProperty('--gap', (eased * maxGap).toFixed(1));
      this.space.style.setProperty('--sweep', eased.toFixed(3));

      // While a layer's callout arrives, the other plies step back.
      const count = this.callouts.length;
      let hero = -1;
      for (let i = 0; i < count; i++) {
        const from = 0.1 + i * 0.22;
        if (t >= from && t < from + 0.22) { hero = i; break; }
      }
      for (let j = 0; j < this.plies.length; j++) {
        // plies render bottom-first, callouts top-first
        const matches = j === this.plies.length - 1 - hero;
        this.plies[j].style.setProperty('--dim', !isMobile && hero > -1 && !matches ? '0.55' : '1');
      }

      if (!isMobile) {
        for (let i = 0; i < count; i++) {
          const c = Math.min(1, Math.max(0, (t - 0.1 - i * 0.22) / 0.22));
          this.callouts[i].style.setProperty('--co', c.toFixed(2));
        }
      }
    }

    onScroll() {
      if (!this.#active || this.#ticking) return;
      this.#ticking = true;
      requestAnimationFrame(this.render);
    }
  }

  if (!customElements.get('wtc-carbon-layers')) {
    customElements.define('wtc-carbon-layers', WtcCarbonLayers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wtc-sf-wing-story"] && !Shopify.designMode) return;
  try {
    
  /**
   * Scroll-driven wing-to-shelf story. One IntersectionObserver arms the
   * title-card reveal and gates the scroll work; all motion values are set
   * per-frame from a single eased progress number.
   */
  class WtcWingStory extends HTMLElement {
    #ticking = false;
    #active = false;
    #revealed = false;
    #pinH = 0;

    connectedCallback() {
      const q = (sel) => this.querySelector(sel);
      this.streaks = q('[data-wws-streaks]');
      this.track = q('[data-wws-track]');
      this.car = q('[data-wws-car]');
      this.wing = q('[data-wws-wing]');
      this.wall = q('[data-wws-wall]');
      this.shelf = q('[data-wws-shelf]');
      this.anchors = q('[data-wws-anchors]');
      this.shadow = q('[data-wws-shadow]');
      this.objects = q('[data-wws-objects]');
      this.svg = q('.wws__svg');
      this.real = q('[data-wws-real]');
      this.pin = q('.wws__pin');
      this.dtrack = q('.wws__dtrack');
      this.callouts = Array.from(this.querySelectorAll('[data-wws-co]'));

      if (!this.car || !this.wing || !this.shelf) return;

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 919px)');

      if (this.reduced.matches) {
        this.#endState();
        return;
      }

      this.onScroll = this.onScroll.bind(this);
      this.render = this.render.bind(this);

      this.io = new IntersectionObserver(
        (entries) => {
          this.#active = entries[0].isIntersecting;
          // The circuit loops (wheels, kerb, body bob) are infinite, so they
          // keep compositing while the section is off screen. Parking them
          // costs a class toggle and buys frames back for the rest of the page.
          this.classList.toggle('wws--live', this.#active);
          if (this.#active) {
            if (!this.#revealed) {
              this.#revealed = true;
              requestAnimationFrame(() => this.classList.add('wws--in'));
            }
            this.render();
          }
        },
        { rootMargin: '-10% 0px' }
      );
      this.io.observe(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      // The frame holds centred in the viewport, which needs its real height.
      // The CSS carries a fallback; this keeps it exact when the copy wraps
      // differently or the cue is switched on.
      if (this.pin && 'ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => {
          const h = this.pin.offsetHeight;
          if (h > 0 && h !== this.#pinH) {
            this.#pinH = h;
            this.style.setProperty('--wws-pin-h', h + 'px');
            this.onScroll();
          }
        });
        this.ro.observe(this.pin);
      }

      // If the photograph arrives while the reader is already sitting at the
      // end of the story, nothing else would trigger the crossfade.
      if (this.real && !this.real.complete) {
        this.real.addEventListener('load', this.render, { once: true });
      }

      this.classList.add('wws--armed');
      if (!this.mobile.matches) {
        for (const co of this.callouts) co.style.setProperty('--co', '0');
      }

      // review mode: freeze any story frame
      const frame = new URLSearchParams(window.location.search).get('wing_frame');
      if (frame !== null) {
        this.frozen = Math.min(1, Math.max(0, parseFloat(frame) || 0));
        this.classList.add('wws--in');
      }
      this.render();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    #endState() {
      this.streaks.setAttribute('opacity', '0');
      this.track.setAttribute('opacity', '0');
      this.car.setAttribute('opacity', '0');
      this.wing.setAttribute('opacity', '0');
      this.wall.setAttribute('opacity', '1');
      this.shelf.setAttribute('opacity', '1');
      this.anchors.setAttribute('opacity', '1');
      this.shadow.setAttribute('opacity', '1');
      this.objects.setAttribute('opacity', '1');
      this.classList.add('wws--real');
      this.svg.style.opacity = '0';
    }

    #progress() {
      if (this.frozen !== undefined) return this.frozen;
      const c01 = (v) => Math.min(1, Math.max(0, v));
      if (this.mobile.matches) {
        // Phones pin the stage only, and the track below it supplies the
        // scroll. The two are adjacent, so the gap that opens between the
        // stage's bottom and the track's top is exactly how far we have
        // scrolled since the stage stuck: zero before it pins, one full track
        // height once the story is done.
        const stage = this.querySelector('.wws__stage');
        const track = this.querySelector('.wws__mtrack');
        if (!stage || !track) return 0;
        const total = track.getBoundingClientRect().height;
        if (total <= 0) return 0;
        const travelled = stage.getBoundingClientRect().bottom - track.getBoundingClientRect().top;
        return c01(travelled / total);
      }
      // Desktop uses the same arrangement one level up: the whole frame pins
      // and the track directly after it supplies the scroll, so the gap
      // between the frame's bottom and the track's top is the distance
      // scrolled since the frame stuck.
      if (!this.pin || !this.dtrack) return 0;
      const tr = this.dtrack.getBoundingClientRect();
      if (tr.height <= 0) return 1;
      return c01((this.pin.getBoundingClientRect().bottom - tr.top) / tr.height);
    }

    render() {
      this.#ticking = false;
      const c01 = (v) => Math.min(1, Math.max(0, v));
      const ease = (t) => 1 - Math.pow(1 - t, 3);
      const p = this.#progress();
      const band = (a, b) => c01((p - a) / (b - a));

      this.streaks.setAttribute('opacity', String(1 - band(0.02, 0.12)));

      const carFade = 1 - ease(band(0.22, 0.48));
      this.car.setAttribute('opacity', String(carFade));
      this.track.setAttribute('opacity', String(carFade));

      const t = ease(band(0.46, 0.72));
      const lift = ease(band(0.46, 0.58));
      this.wing.setAttribute('opacity', String(1 - band(0.56, 0.64)));
      this.wing.style.transform =
        'translate(' + (-258 * t) + 'px,' + (-18 * t - 24 * lift) + 'px) rotate(' + (5 * t) + 'deg)';
      this.wall.setAttribute('opacity', String(ease(band(0.54, 0.68))));
      this.shelf.setAttribute('opacity', String(band(0.60, 0.70)));
      this.shelf.style.transform = 'translateY(' + (30 * (1 - t)) + 'px)';

      this.anchors.setAttribute('opacity', String(ease(band(0.70, 0.77))));
      this.shadow.setAttribute('opacity', String(ease(band(0.72, 0.80))));
      this.objects.setAttribute('opacity', String(ease(band(0.76, 0.85))));

      // Hold the sketch until the photograph can actually replace it. Hiding
      // the SVG against an image that has not arrived is what shows the bare
      // wall as a grey flash on slow connections.
      const photoReady = !this.real || this.real.complete;
      const real = p > 0.88 && photoReady;
      this.classList.toggle('wws--real', real);
      this.svg.style.opacity = real ? '0' : '1';

      if (!this.mobile.matches) {
        const starts = [0.38, 0.62, 0.78];
        for (let i = 0; i < this.callouts.length; i++) {
          const o = ease(band(starts[i] ?? 0.8, (starts[i] ?? 0.8) + 0.1));
          this.callouts[i].style.setProperty('--co', o.toFixed(2));
        }
      }
    }

    onScroll() {
      if (!this.#active || this.#ticking) return;
      this.#ticking = true;
      requestAnimationFrame(this.render);
    }
  }

  if (!customElements.get('wtc-wing-story')) {
    customElements.define('wtc-wing-story', WtcWingStory);
  }

  } catch(e) { console.error(e); }
})();
})();
